import { generateTestId } from "@client-shared";

export const setNotificationsViewTestId = (identifier: string): string =>
  generateTestId("NotificationsView", identifier);

// Container
export const setNotificationsViewContainerTestId = (): string =>
  setNotificationsViewTestId("container");

// Header elements
export const setNotificationsViewTitleTestId = (): string =>
  setNotificationsViewTestId("title");
export const setNotificationsViewDescriptionTestId = (): string =>
  setNotificationsViewTestId("description");
export const setNotificationsViewUnreadBadgeTestId = (): string =>
  setNotificationsViewTestId("unread-badge");

// Notification list
export const setNotificationsViewListTestId = (): string =>
  setNotificationsViewTestId("list");
export const setNotificationsViewCardTestId = (id: number): string =>
  setNotificationsViewTestId(`card-${id}`);
